import { CreateTownhallFormProps } from "../CreateTownhallForm";
import { StyledWrapper } from "./styledComponents";
import { translate } from "@kaltura/ds-react-utils";
import { SelectField } from "@kaltura/mediaspace-shared-ui/controlled-form";

const baseClassName = "kms-ds-create-townhall-form-event-recording";

/**
 * EventRecording component
 * This component renders a select dropdown for choosing the event recording mode.
 */
const EventRecording = (props: Pick<CreateTownhallFormProps, "recordingOptions" | "defaultRecordingMode">) => {
    const { recordingOptions, defaultRecordingMode } = props;

    return (
        <StyledWrapper className={baseClassName}>
            <SelectField
                id={"recordingMode"}
                label={translate("Event Recording")}
                options={recordingOptions}
                fontWeightBold={true}
                value={defaultRecordingMode.value}
                inline={true}
                className={`${baseClassName}-select`}
            />
        </StyledWrapper>
    );
};

export default EventRecording;
